<template>
    <ClientOnly>
        <TranslateButton v-if="isTranslationActivated && certificationSectionState.length > 0" section="certification" />
        <template #fallback>
            <SectionActionSkeleton />
        </template>
    </ClientOnly>
</template>
<script setup lang="ts">
    import {onUnmounted} from 'vue';
    import {storeToRefs} from 'pinia';
    import {onMounted} from '#imports';
    import TranslateButton from '~/components/main/TranslateButton.vue';
    import SectionActionSkeleton from '~/components/section/SectionActionSkeleton.vue';
    import {eventBus} from '~/config/events';
    import {useCertificationSectionState} from '~/features/certifications/composables/useCertificationSectionState';
    import {TranslationDirection, useTranslationStore} from '~/store/translation/translationStore';

    const translationSection = 'certifications';
    const translationField = 'title';

    // State
    const certificationSectionState = useCertificationSectionState();

    // Stores
    const {translateAll, replaceTranslationContent} = useTranslationStore();
    const {isTranslationActivated} = storeToRefs(useTranslationStore());

    onMounted(() => {
        eventBus.on('translation:request', translateCertifications);
        eventBus.on('translation:restore', restoreCertifications);
    });

    onUnmounted(() => {
        eventBus.off('translation:request', translateCertifications);
        eventBus.off('translation:restore', restoreCertifications);
    });

    async function translateCertifications() {
        const certificationContentRequests = certificationSectionState.value.map((certification) => {
            return {
                section: translationSection,
                field: translationField,
                index: certification.index,
                originalContent: certification.title ?? ' ',
            };
        });

        await translateAll(certificationContentRequests);
        replaceTranslationContent(translationSection, translationField, TranslationDirection.TRANSLATE, switchTranslation);
    }

    function restoreCertifications() {
        replaceTranslationContent(translationSection, translationField, TranslationDirection.RESTORE, switchTranslation);
    }

    function switchTranslation(content: string, index: number, field: string) {
        (certificationSectionState.value[index] as any)[field] = content;
    }
</script>
